import React from "react";
import TextAtm from "../../../../atoms/TextAtm";
function Label(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(TextAtm, {
    typography: "big3",
    color: "secondary"
  }, children);
}
export default Label;